



























import PullRefresh from '@/packages/m-pull-refresh';
import MTabs from '@/packages/m-tabs';
import Vue from 'vue';
import Component from 'vue-class-component';
import {Watch} from 'vue-property-decorator';

Vue.use(PullRefresh);
Vue.use(MTabs);

@Component({
  name: 'Components'
})
export default class Components extends Vue {

  public loading: boolean = false;

  @Watch('loading')
  public loadingChanged() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  }
}
